import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-avatar-serv',
  templateUrl: './avatar-serv.component.html',
  styleUrls: ['./avatar-serv.component.css']
})
export class AvatarServComponent{
  @Input() 
  tipo: string;
  @Input()
  class: string;
  @Input()
  size: string;
  @Input()
  icon: string;
  get _tipo() : string {
    return this.tipo?.charAt(0);
  }

  get _tipoStyle() : any{
    switch (this._tipo) {
      case "D":
        
        return {'background-color': '#4baaf5', 'color': '#FFFFFF'}
         
        break;
      case "R":
        return {'background-color': '#4caf50', 'color': '#FFFFFF'}

        break;
    
      case "F":
        return {'background-color': '#fbc02d', 'color': '#616161'}

        break;

      case "V":
        return {'color': '#616161'}

        break;
      
      default:

        break;
    }
  }

  constructor() { }

}
